type Target = '_self' | '_blank' | '_system';

export class CordovaUtils {
  static openLink(url: string, target: Target = '_system'): void {
    window.open(url, target);
  }
}
